import type { FC } from 'react'
import { Item } from '~/components/text'
import { Address } from '~/components/addressModel'
import {
  BicycleGenreModel,
  PartGenreModel,
  SupplyGenreModel,
  ProductModelJSON,
} from '~/models'

type Props = {
  product: ProductModelJSON
}

export const ProductDetail: FC<Props> = ({ product }) => {
  return (
    <>
      <h2 className="mb-2 text-gray-800 text-xs">商品情報</h2>
      {product.type === 0 && product.bicycle && (
        <>
          <Item title="モデル" text={product.bicycle.name} className="mt-2" />
          <Item title="年式" text={product.bicycle.year?.toString()} className="mt-2" />
          <Item title="サイズ" text={product.bicycle.size} className="mt-2" />
        </>
      )}
      {product.type === 1 && product.part && (
        <>
          <Item title="モデル" text={product.part.name} className="mt-2" />
          <Item title="サイズ" text={product.part.size} className="mt-2" />
        </>
      )}
      {product.type === 2 && product.supply && (
        <>
          <Item title="モデル" text={product.supply.name} className="mt-2" />
          <Item title="サイズ" text={product.supply.size} className="mt-2" />
        </>
      )}
      {product.minTargetHeight && product.maxTargetHeight &&
        <Item
          title="対象身長"
          text={
            product.minTargetHeight.toString()
            + '~'
            + product.maxTargetHeight.toString()
            + ' cm'
          }
          className="mt-2"
        />
      }
      {product.type === 0 && product.bicycle && (
        <>
          <Item title="カラー" text={product.bicycle.color} className="mt-2" />
          <Item title="ジャンル" text={BicycleGenreModel.getDisplayName(product.bicycle.genre)} className="mt-2" />
          <Item title="メーカー" text={product.bicycle.maker.name} className="mt-2" />
          <Item title="状態" text={product.new ? '新車' : '中古車'} className="mt-2" />
        </>
      )}
      {product.type === 1 && product.part && (
        <>
          <Item title="カラー" text={product.part.color} className="mt-2" />
          <Item title="ジャンル" text={PartGenreModel.getDisplayName(product.part.genre)} className="mt-2" />
          <Item title="メーカー" text={product.part.maker.name} className="mt-2" />
          <Item title="状態" text={product.new ? '新品' : '中古'} className="mt-2" />
        </>
      )}
      {product.type === 2 && product.supply && (
        <>
          <Item title="カラー" text={product.supply.color} className="mt-2" />
          <Item title="ジャンル" text={SupplyGenreModel.getDisplayName(product.supply.genre)} className="mt-2" />
          <Item title="メーカー" text={product.supply.maker.name} className="mt-2" />
          <Item title="状態" text={product.new ? '新品' : '中古'} className="mt-2" />
        </>
      )}
      <Item
        title="価格 (税込み)"
        text={product.price === undefined ? '要問い合わせ' : `¥${product.price.toLocaleString()}`}
        className="mt-2"
      />
      {product.cartEnabled ? (
        <Item title="送料" text={product.isCashOnDelivery ? '着払い' : 'ショップ負担'} className="mt-2" />
      ) : ''}
      <h2 className="mt-4 mb-2 text-gray-800 text-xs">ショップ情報</h2>
      {product.shop && (
        <Item title="店舗名" text={product.shop.name} className="mt-2" />
      )}
      {product.shop?.address && (
        <Address address={product.shop.address} className="mt-2" />
      )}
    </>
  )
}
